<div class="container">
  <div class="row center">
    <p class="bold">{{ 'merit-budget.hr-research.compensation-deviation.headline' | translate }}</p>
  </div>
  <div class="row center">
    <p>{{ 'merit-budget.hr-research.compensation-deviation.expected' | translate }}</p>
  </div>
  <div
    class="scale-container"
    [matTooltip]="warningText | translate">
    <div class="scale">
      <div
        #indicatorWrapper
        class="indicator-wrapper below">
        @if (isBelowExpectations) {
          <div class="separator">
            <div class="square"></div>
          </div>
        }
        <div
          #belowIndicator
          class="indicator"
          [ngClass]="{ green: isInsideExpectations, orange: hasSmallDiff, red: hasHugeDiff }"></div>
      </div>
    </div>

    <div class="scale">
      <div class="indicator-wrapper above">
        @if (isAboveExpectations) {
          <div class="separator">
            <div class="square"></div>
          </div>
        }
        <div
          #aboveIndicator
          class="indicator"
          [ngClass]="{ green: isInsideExpectations, orange: hasSmallDiff, red: hasHugeDiff }"></div>
      </div>
    </div>
  </div>
  <div class="row text-row">
    <div class="info-text-wrapper">
      <p
        #text
        class="bold"
        [matTooltip]="warningText | translate"
        [ngClass]="{ green: isInsideExpectations, orange: hasSmallDiff, red: hasHugeDiff }">
        {{ expectationText | translate }}
      </p>
    </div>
  </div>
</div>
<div class="information-text">
  <p>{{ 'merit-budget.hr-research.compensation-deviation.description' | translate }}</p>
</div>
